import React, { PureComponent } from 'react';
import { NavLink } from 'react-router-dom';
import { strings, getCurrentLocale } from '../../../localization';

export default class StatsDropdown extends PureComponent {

    constructor(props) {

        super(props);

        this.state = {
            active: false
        }
    }

    componentDidMount() {

        window.addEventListener('click', this.onBlur)
    }

    componentWillUnmount() {

        window.removeEventListener('click', this.onBlur)
    }

    toggleActive = (e) => {

        this.setState({
            active: !this.state.active
        })
    }

    onBlur = (e) => {

        if (e.target != this.ref)
            this.setState({
                active: false
            })
    }

    render() {

        const currentLocale = getCurrentLocale();
        var btnClasses = [
            "btn-dropdown"
        ]

        if (this.state.active) btnClasses.push('active');

        return (
            <span>
                <a className={btnClasses.join(' ')}
                    onClick={this.toggleActive}
                    ref={ref => { this.ref = ref; }}>
                    {strings.formatString(strings.stats)}
                </a>
                <span>
                    <NavLink className="dropdown-links" to={'/' + currentLocale + '/stats/history/default'} activeClassName="active">{strings.formatString(strings.history)}</NavLink>
                    <NavLink className="dropdown-links" to={'/' + currentLocale + '/stats/reports'} activeClassName="active">{strings.formatString(strings.reports)}</NavLink>
                    <NavLink className="dropdown-links" to={'/' + currentLocale + '/stats/heatmap/default'} activeClassName="active">{strings.formatString(strings.heatmaps)}</NavLink>
                </span>
            </span>
        )
    }
}
